//
import ProductModel from '@/models/Warehouse/WhProductToSearch'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import UserModel from '@/models/General/GUser'

//
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/list/headers'
import StocksTrigger from '@/services/triggers/stocks'
import { required } from '@/services/validations'
import DispatchRequestDetailHeaders from './headers'

//
const PRODUCTS_KEY = 'wh_selected_products'
const FROM_WAREHOUSE_KEY = 'wh_from_warehouse_id'
const FROM_VALUE_KEY = 'stock'
const TO_WAREHOUSE_KEY = 'wh_to_warehouse_id'
const TO_VALUE_KEY = 'stock_to'

/**
 * @description
 * Trigger wh selected products
 *
 * @param      {<type>}  ctx     The context
 */
const trigger_wh_selected_products = ctx => {

    //
    const trigger_wh_from_warehouse = ctx.getInput('wh_from_warehouse_id')._events.input.slice().pop()
    const trigger_wh_to_warehouse = ctx.getInput('wh_to_warehouse_id')._events.input.slice().pop()

    //
    trigger_wh_from_warehouse(ctx.value.wh_from_warehouse_id)    
    trigger_wh_to_warehouse(ctx.value.wh_to_warehouse_id)
}

/**
 * @description
 * Trigger wh from warehouse id
 *
 * @type       {Function}
 */
const trigger_wh_from_warehouse_id = StocksTrigger({
    productsKey: PRODUCTS_KEY,
    warehouseKey: FROM_WAREHOUSE_KEY,
    valuekey: FROM_VALUE_KEY,
})

/**
 * @description
 * Trigger wh from warehouse id
 *
 * @type       {Function}
 */
const trigger_wh_to_warehouse_id = StocksTrigger({
    productsKey: PRODUCTS_KEY,
    warehouseKey: TO_WAREHOUSE_KEY,
    valuekey: TO_VALUE_KEY,
})

/**
 * @description
 * Transfer between warehouses create fields
 */
export default ({ g_branch_office_id, triggerWarehouse }) => [
    {
        name: 'g_from_supervisor_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            rules: [required],
        },
    },
    {
        name: 'wh_from_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Origen',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            rules: [required],
        },
        trigger: trigger_wh_from_warehouse_id,
    },
    {
        name: 'wh_to_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Destino',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            rules: [required],
        },
        trigger: trigger_wh_to_warehouse_id,
    },
    {
        name: 'g_to_supervisor_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Solicitante',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            //readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_selected_products',
        type: 'data-table-model',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: DispatchRequestDetailHeaders,
            noActions: true,
            noDataText: 'Sin productos.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            label: 'Items',
            pickerProps: {
                attachParams: {
                    stock_branch_office_id: g_branch_office_id,
                },
                filters: ProductFilters({ triggerWarehouse }).slice(0, -1),
                headers: JSON.parse(JSON.stringify(ProductHeaders)).filter((e,i)=> i!==5).map(e => {
                    if(e.value === 'stock_total') {
                        e.value = 'stock_branch_office'
                    }
                    return e
                }),
                noPagination: false,
                mapper: row => {
                    row['g_branch_office_id'] = g_branch_office_id
                    row['quantity'] = 1
                    row['stock'] = 0
                    row['stock_to'] = 0
                    row['wh_product_id'] = row.id
                    return row
                },
                paramFilter: {
                    type: 'item',                    
                },
                rowsPerPage: 15,
                submitText: 'confirmar selección',
                service: ProductModel,
                title: 'Seleccionar producto',
            },
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: 'Lista de productos incluidos en la guía',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            rules: [required],
        },
        trigger: trigger_wh_selected_products,
    },
    {
        name: 'description',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Descripción',
        },
    },
]
